module.exports = __webpack_public_path__ + "static/media/themed.5797a88e.png";